/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeWeightingStatusRequest } from '../../models/change-weighting-status-request';

export interface ApiWeightingChargerIdConnectorIdStatusPut$Params {
  chargerId: string;
  connectorId: number;
      body?: ChangeWeightingStatusRequest
}

export function apiWeightingChargerIdConnectorIdStatusPut(http: HttpClient, rootUrl: string, params: ApiWeightingChargerIdConnectorIdStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWeightingChargerIdConnectorIdStatusPut.PATH, 'put');
  if (params) {
    rb.path('chargerId', params.chargerId, {});
    rb.path('connectorId', params.connectorId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWeightingChargerIdConnectorIdStatusPut.PATH = '/api/Weighting/{chargerId}/{connectorId}/status';
